import axios from '@/libs/api.request';

export const getWarehouseList = data => {
    return axios.request({
        url: 'api/warehouseManagement/getWarehouseList',
        data: data,
        method: 'post'
    });
};

export const saveWarehouse = data => {
    return axios.request({
        url: 'api/warehouseManagement/saveWarehouse',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmWarehouseList = () => {
    return axios.request({
        url: 'api/warehouseManagement/getSeedFarmWarehouseList',
        data: {},
        method: 'post'
    });
};

export const getCurSaleWarehouseProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/curSalePriceAdjust/getCurSaleWarehouseProductStore',
        data: data,
        method: 'post'
    });
};

export const curSaleUpdateAdjustPrice = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/curSalePriceAdjust/curSaleUpdateAdjustPrice',
        data: data,
        method: 'post'
    });
};

export const curSaleInnerOuterTransfer = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/curSalePriceAdjust/curSaleInnerOuterTransfer',
        data: data,
        method: 'post'
    });
};

export const curSaleStoreDiscard = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/discard/curSaleStoreDiscard',
        data: data,
        method: 'post'
    });
};

export const getCurSaleDiscardList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/discard/getCurSaleDiscardList',
        data: data,
        method: 'post'
    });
};

export const exportCurSaleDiscardList = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/discard/exportCurSaleDiscardList',
        data: data,
        method: 'post'
    });
};

export const getCurSaleDiscardDetail = curSaleWarehouseStoreDiscardRecordUuid => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/discard/getCurSaleDiscardDetail',
        data: { curSaleWarehouseStoreDiscardRecordUuid },
        method: 'post'
    });
};

export const getPreSaleWarehouseProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/getPreSaleWarehouseProductStore',
        data: data,
        method: 'post'
    });
};

export const getWarehouseForwardProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/warehouseStore/getWarehouseForwardProductStore',
        data: data,
        method: 'post'
    });
};

export const getSelfWarehouseProductStore = data => {
    return axios.request({
        url: 'api/warehouseManagement/selfWarehouseStore/store/getSelfWarehouseProductStore',
        data: data,
        method: 'post'
    });
};


export const getSelfWarehouseJournalList = data => {
    return axios.request({
        url: 'api/warehouseManagement/selfWarehouseStore/EntryConsume/getSelfWarehouseJournalList',
        data: data,
        method: 'post'
    });
};

export const saveSelfWarehouseEntry = data => {
    return axios.request({
        url: 'api/warehouseManagement/selfWarehouseStore/EntryConsume/saveSelfWarehouseEntry',
        data: data,
        method: 'post'
    });
};

export const saveSelfWarehouseConsume = data => {
    return axios.request({
        url: 'api/warehouseManagement/selfWarehouseStore/EntryConsume/saveSelfWarehouseConsume',
        data: data,
        method: 'post'
    });
};

